<template>
  <div
    v-if="showProducts"
    class="sf-context-toggle"
    role="radiogroup"
    aria-label="Spot / Futures"
  >
    <button
      v-for="p in produtos"
      :key="p.key"
      type="button"
      role="radio"
      class="sf-context-btn"
      :class="{ active: contextoAtual === p.key }"
      :aria-checked="contextoAtual === p.key ? 'true' : 'false'"
      @click="trocarContexto(p.key)"
    >
      {{ p.name }}
    </button>
  </div>
</template>

<script>
// Segmented control Spot/Futures da sidebar (redesign Soulf).
// Mesma lógica de navegação do antigo chip do navbar (Produto.vue).
import { getContext, setContext, isHaveProduct } from '@/auth/utils'

export default {
  name: 'ProdutoToggle',

  computed: {
    contextoAtual() {
      // a rota é a fonte da verdade (navegação direta por URL não passa por setContext)
      const path = (this.$route && this.$route.path) || ''
      if (path.startsWith('/futures')) return 'futures'
      if (path.startsWith('/spot')) return 'spot'
      return getContext()
    },

    showProducts() {
      return isHaveProduct('futures') && isHaveProduct('spot')
    },
  },

  methods: {
    trocarContexto(key) {
      if (key === this.contextoAtual) return
      setContext(key)
      window.location.href = `/${key}`
    },
  },

  setup() {
    const produtos = [
      { key: 'spot', name: 'Spot' },
      { key: 'futures', name: 'Futures' },
    ]

    return { produtos }
  },
}
</script>

<style lang="scss" scoped>
.sf-context-toggle {
  display: flex;
  gap: 3px;
  margin: 10px 14px 6px;
  padding: 3px;
  background: #0F0F11;
  border: 1px solid rgba(255, 255, 255, 0.10);
  border-radius: 10px;

  .sf-context-btn {
    flex: 1;
    padding: 7px 0;
    border: 0;
    border-radius: 7px;
    background: transparent;
    color: #8b8f98;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: background .15s ease, color .15s ease;

    &:hover { color: #fff; }
    &.active { background: #3b82f6; color: #fff; }
  }
}
</style>
